var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompetition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9316 0H4.06841C1.82149 0 0 1.82149 0 4.06841V19.9316C0 22.1785 1.82149 24 4.06841 24H19.9316C22.1785 24 24 22.1785 24 19.9316V4.06841C24 1.82149 22.1785 0 19.9316 0Z",
    fill: "url(#paint0_linear_301_2)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_301_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 14,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9677 4.60645H5.03223V18.5419H18.9677V4.60645Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_301_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8628 7.50967L17.2722 4.91709L12 4.60645L6.72771 4.91999L7.13707 7.51254H5.03223V7.80286C5.03223 11.4464 7.96743 14.4164 11.5965 14.4774C11.2422 15.4413 10.11 17.9641 7.93545 17.9641V18.5448H16.0645V17.9641C13.8899 17.9641 12.7577 15.4413 12.4035 14.4774C16.0325 14.4164 18.9677 11.4464 18.9677 7.80286V7.51254H16.8628V7.50967ZM12 5.18709L16.5987 5.45999L16.0732 8.78415C15.6841 11.2461 14.2442 13.8968 12 13.8968C9.75581 13.8968 8.35932 11.3274 7.9267 8.78415L7.40126 5.45999L12 5.18709ZM5.61868 8.09032H7.22997L7.35481 8.87705C7.7467 11.188 8.62061 12.6629 9.61065 13.5164C7.36642 12.689 5.73771 10.5871 5.61868 8.09032ZM14.1948 17.9613H9.80807C10.9461 17.2035 11.6487 15.8738 12.0028 15.0319C12.3542 15.8738 13.0567 17.2035 14.1977 17.9613H14.1948ZM14.3748 13.5222C15.5884 12.4452 16.3694 10.6161 16.6451 8.87419L16.77 8.09032H18.3813C18.2622 10.5929 16.6277 12.7006 14.3777 13.5222H14.3748Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_301_2",
    x1: 0,
    y1: 12,
    x2: 24,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06A099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#189CD9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetition);
export default __webpack_public_path__ + "static/media/competition.3ca616797c89d93bbdf31ffee8d67409.svg";
export { ForwardRef as ReactComponent };